type IsSameDatParams = {
  dateA: Date;
  dateB: Date;
};

export const isSameDay = ({ dateA, dateB }: IsSameDatParams) =>
  dateA.toLocaleDateString() === dateB.toLocaleDateString();
